import React from 'react';
import { Button } from 'react-bootstrap';
import { AiOutlineClose } from 'react-icons/ai';

const AutoDetection = ({
    count,
    onUndo,
    onDismiss,
    onAutoDetect,
    autoDetecting = false,
    showButton = false,
    disabled = false,
}) => {
    if (count > 0) {
        return (
            <div
                className="d-flex align-items-center justify-content-between mb-3 px-4 py-3"
                style={{ background: '#18245c', borderRadius: 6, color: 'white' }}
            >
                <div style={{ fontSize: 18 }}>
                    We&apos;ve found <span style={{ color: '#80c900', fontWeight: 700 }}>{count}</span> fields in your
                    document.
                </div>
                <div className="d-flex align-items-center gap-3">
                    <Button variant="outline-light" onClick={onUndo} disabled={disabled} className="mr-2">
                        Undo
                    </Button>
                    <AiOutlineClose
                        aria-label="Dismiss auto-detection notice"
                        role="button"
                        tabIndex={disabled ? -1 : 0}
                        onClick={onDismiss}
                        style={{ color: 'white', cursor: disabled ? 'default' : 'pointer' }}
                        size={20}
                    />
                </div>
            </div>
        );
    }

    if (!showButton) return null;
    return (
        <div className="d-flex flex-grow-1 justify-content-center">
            <Button
                variant="success"
                onClick={onAutoDetect}
                disabled={autoDetecting || disabled}
                style={{ whiteSpace: 'nowrap' }}
            >
                {autoDetecting ? 'Detecting...' : '✨ Auto-Detect Fields'}
            </Button>
        </div>
    );
};

export default AutoDetection;
